<template>
  <div class="vld-parent">
    <loading :v-model="isLoading"></loading>
    <div class="hello">
      <h1 class="page-title">{{ msg }}</h1>
      <nav class="tag-list">
        <ul>
          <li v-for="(tag, index) in hashtagData" v-bind:key="index">
            <a :data-slug="tag" v-on:click="selectTag"> #{{ tag }} </a>
          </li>
        </ul>
      </nav>
      <div id="map"></div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  setup() {
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute(
      'src',
      'https://cdn.geolonia.com/v1/embed?geolonia-api-key=d42efbee7ac24f3ab7e8f7589103b48f'
    )
    document.body.append(recaptchaScript)
    document.title = '湯の街魅力マップ'
  },
  name: 'OnsenMap',
  data() {
    return {
      mapData: [],
      hashtagData: [],
      markerData: [],
      map: null,
      isLoading: false,
    }
  },
  components: {
    loading: Loading,
  },
  props: {
    msg: String,
  },
  methods: {
    async loadMap() {
      if (this.mapData.length) {
        console.log('map data ready!')
      } else {
        await this.fetchMapData()
        console.log('build map...')
        let latitude = 140.84993494565177,
          longitude = 37.00654958401859

        // eslint-disable-next-line
        this.map = new geolonia.Map({
          container: '#map',
          center: [latitude, longitude],
          zoom: 12,
        })
        this.map.on('load', () => {
          this.loadMarkers()
        })
      }
    },
    async loadMarkers(target) {
      console.log('..loading map data')
      const markerData = this.mapData.reduce((r, a) => {
        r[a.hashtag] = r[a.hashtag] || []
        r[a.hashtag].push(a)
        return r
      }, Object.create(null))
      //   console.dir(markerData)
      target = target ? target : '湯の街グルメ' //デフォルトはグルメ
      console.log(target)
      //   console.dir(markerData[target])

      //スポットごとにグループ分け
      const markerGroup = await markerData[target].reduce((r, a) => {
        r[a.spot] = r[a.spot] || []
        r[a.spot].push(a)
        // if (a.postid) r[a.spot]['files'].push(a.postid)
        // if (a.folderid) r[a.spot]['files'].push(a.folderid)
        return r
      }, Object.create(null))
      //   console.log('spot group')
      //   console.dir(markerGroup)

      //すべてのファイルを1つの配列に統合
      for (const group in markerGroup) {
        let fileList = []
        await markerGroup[group].forEach((e) => {
          if (e.folderid) {
            e.folderid.forEach((f) => {
              let data = {
                postid: f,
                userUrl: e.userUrl,
              }
              //   fileList.push(f)
              fileList.push(data)
            })
          }
          if (e.postid) {
            let data = {
              postid: e.postid,
              userUrl: e.userUrl,
            }
            // fileList.push(e.postid)
            fileList.push(data)
          }
        })
        markerGroup[group].filelist = fileList
      }
      //   console.dir(markerGroup)

      //   markerData[target].forEach((element) => {
      for (const group in markerGroup) {
        // console.dir(markerGroup[group])
        const markerProp = markerGroup[group][0]

        if (!markerProp.location) continue
        // console.dir(markerProp)

        let imgList = '<div class="img-wrapper">'
        await markerGroup[group].filelist.forEach((element) => {
          //   console.dir(element)
          // ポップアップを作成
          imgList +=
            '<a class="post-img-url" href="' +
            element.userUrl +
            '" target="_blank"><img class="post-img" src="https://drive.google.com/uc?export=view&id=' +
            element.postid +
            '"></a>'
        })
        imgList += '</div>'

        const title =
            '<h4 class="spot-item-title">' + markerProp.spot + '</h4>',
          spotUrl = markerProp.spotUrl
            ? '<a class="spot-link" href="' +
              markerProp.spotUrl +
              '" target="_blank">' +
              markerProp.spotUrl +
              '</a>'
            : '',
          popupOffsets = {
            top: [0, 0],
            'top-left': [0, 0],
            'top-right': [0, 0],
            bottom: [0, 0],
            'bottom-left': [0, 0],
            'bottom-right': [0, 0],
            left: [0, 0],
            right: [0, 0],
          },
          // eslint-disable-next-line
          popup = new geolonia.Popup({
            className: 'popup-spot',
            maxWidth: '100%',
            anchor: 'center',
            offset: popupOffsets,
          }).setHTML(title + spotUrl + imgList),
          markerStyle = {
            color: '#f00',
          },
          location = markerProp.location.split(', '),
          // マーカーを作成
          // eslint-disable-next-line
          marker = new geolonia.Marker(markerStyle)
            // 緯度経度を指定
            .setLngLat([location[1], location[0]])
            // マーカーにポップアップをセット
            .setPopup(popup)
            // 地図にマーカーを追加
            // eslint-disable-next-line
            .addTo(this.map)

        this.markerData.push(marker)
      }
    },
    async fetchMapData() {
      console.log('fetching data...')
      this.isLoading = true
      const endpoint =
        'https://script.google.com/macros/s/AKfycbzj_LGRjneH5LEKL5wxkOtoy3l5t2AOxWqb4CZ_-kMswfMW1vEiR4kPQ8I5Zxy0zunT/exec'
      await fetch(endpoint, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
        .then((response) => {
          return response.json()
        })
        .then((data) => {
          //   console.dir(data)
          data.data.forEach((element) => {
            // console.dir(element)
            let postData = {
              spot: element.spot,
              hashtag: element.hashtag,
              location: element.location,
              postid: element.postid,
              folderid: element.folderid,
              spotUrl: element.url,
              userUrl: element.posturl,
            }
            this.mapData.push(postData)
          })
          data.hashtags.map((tag) => {
            this.hashtagData.push(tag.name)
          })
        })
        .catch((e) => {
          console.log(e) //エラーをキャッチし表示
        })
        .finally(() => {
          console.log('map data loaded')
          //   console.dir(this.mapData)
          this.isLoading = false
        })
    },
    async selectTag(tag) {
      const targetTag = tag.target,
        target = tag.target.dataset.slug,
        selectTabWrap = document.querySelectorAll('.tag-list li a')
      console.dir(target)
      console.dir(targetTag)

      await selectTabWrap.forEach((e) => {
        e.classList.remove('active')
      })
      targetTag.classList.add('active')
      //マーカーを削除
      await this.markerData.forEach((element) => {
        element.remove()
      })
      this.loadMarkers(target)
    },
    filterMarker(target) {
      const markerList = this.mapData.filter((element) => {
        return element.hashtag == target
      })
      //   console.dir(markerList)
      this.loadMarkers(markerList)
    },
  },
  mounted() {
    // console.log(import.meta.env.SHEET_URL)

    this.loadMap()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.page-title {
  font-size: 1.4rem;
  margin-bottom: 0;
}
#map {
  width: 100%;
  height: calc(100vh - 150px);
  background-color: #ddd;
}
.tag-list {
  display: block;
  min-height: 60px;
  padding: 10px 0;
  ul {
    margin: 0;
  }
  a {
    padding: 0.25em;
    display: block;
    cursor: pointer;
    &:hover {
      background-color: #eee;
    }
    &.active {
      background-color: #eee;
    }
  }
}
</style>
<style lang="scss">
.popup-spot {
  width: 100%;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  height: 90% !important;
  overflow: hidden;
  z-index: 100;
  padding-bottom: 1em;
  .maplibregl-popup-close-button {
    font-size: 2rem;
  }
  .maplibregl-popup-content {
    width: 100%;
    padding: 1em;
    border-bottom: 1em solid #fff;
  }
  .mapboxgl-popup-tip {
    display: none;
  }
  .spot-item-title {
    font-weight: 600;
    margin: 10px auto;
    font-size: 1.2rem;
  }
  .spot-link {
    display: block;
    width: 100%;
    &:focus {
      outline: none;
    }
  }
  .img-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 1em;
    margin-top: 20px;
    justify-content: space-between;
    overflow-y: scroll;
    max-height: 83%;
    &::after {
      content: '';
      display: inline-block;
      width: calc(100% / 3 - 0.75em);
      margin-right: auto;
    }
  }
  .post-img-url {
    display: block;
    width: calc(100% / 3 - 0.75em);
  }
  .post-img {
    aspect-ratio: 1;
    width: 100%;
    object-fit: cover;
    display: inline-block;
  }
}
.vld-overlay {
  &[v-model='true'] {
    display: block !important;
    &::before {
      content: 'Loading';
      position: absolute;
      top: 60%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .vld-icon {
    top: 45%;
  }
}
</style>
